import http from "./http";

class DetailsCommandesService {
    index(){
        return http.get("/api/commandes")
    }

    store(data){
        return http.post("/api/detailscommandes/store", data)
    }

    edit(id){
        return http.get(`/api/detailscommandes/${id}/edit`)
    }

    show(id){
        return http.get(`/api/detailscommandes/${id}/show`)
    }

    update(id, data){
        return http.post(`/api/detailscommandes/${id}/update`, data)
    }

    delete(id){
        return http.delete(`/api/detailscommandes/${id}/delete`)
    }
}

export default new  DetailsCommandesService()